import PropTypes from 'prop-types'
import { Button, ButtonGroup, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react'

export const ModalConfirmation = ({ isOpen, onClose, heading, description, btnConfirmLabel = 'Confirm', btnCancelLabel = 'Cancel', onConfirm, isConfirming }) => {
  return (
    <>
      <Modal size="xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{heading}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>{description}</Text>
          </ModalBody>
          <ModalFooter>
            <ButtonGroup gap={4}>
              <Button colorScheme="blue" size="sm" onClick={onConfirm} isLoading={isConfirming}>{btnConfirmLabel}</Button>
              <Button variant="ghost" colorScheme="gray" size="sm" onClick={onClose}>{btnCancelLabel}</Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

ModalConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  heading: PropTypes.string,
  description: PropTypes.string,
  btnConfirmLabel: PropTypes.string,
  btnCancelLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  isConfirming: PropTypes.bool
}
